export * from '../../mvlabs-components-fe/ui/components/Layout/SideBar/SideBar'

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

// interface BE data new Login
export interface VidimCoreAuth {
  token: string
  user: VidimCoreUser
}

export interface VidimCoreUser {
  uuid: string
  firstName: string
  lastName: string
  userName: string
  email?: string
  roles: string[]
  aclRules: string[]
  properPositionUuid: string
  derivedPositions: string[]
  uiTheme?: string
}

export interface UserParams {
  uuid: string
  username: string
  displayName: string
  roles: string[]
  forbiddenActions: string[]
  aclRules: { [acl: string]: boolean }
  uiTheme?: string
}

export interface Branding {
  uiTheme: string
}

// user used (and saved) around Vidim
export class User {
  public uuid: string
  public username: string
  public displayName: string
  public roles: string[]
  public forbiddenActions: string[]
  public aclRules: { [acl: string]: boolean }
  public branding: Branding

  constructor(params: Partial<UserParams>) {
    this.uuid = params.uuid || ''
    this.username = params.username || ''
    this.displayName = params.displayName || ''
    this.roles = params.roles || []
    this.forbiddenActions = params.forbiddenActions || []
    this.aclRules = params.aclRules || {}
    this.branding = (params.uiTheme && { uiTheme: params.uiTheme }) || { uiTheme: '' }
  }

  public can(action?: string | string[]): boolean {
    let can = true

    if (action === undefined) {
      return can
    }
    if (Array.isArray(action)) {
      action.forEach(acl => {
        can = can && this.can(acl)
      })
      return can
    }
    return this.canDo(action) || this.canView(action)
  }

  private canDo(action: string): boolean {
    return this.aclRules[action]
  }

  private canView(action: string): boolean {
    return this.aclRules[`view.${action}`]
  }
}
